module.exports = __webpack_public_path__ + "static/media/banner-marketing.f64389b4.png";